export enum GeometryType {
    LOCATION = "location",
    BOUNDARY = "boundary",
}